import styled from "styled-components";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Colors } from "../theme";
import {
  getAutoOpenUserAppUrl,
  getDownloadInfo,
  getOpenUserAppUrl,
} from "../utils/storeLinks";

function UserShare() {
  const { userId = "" } = useParams();
  const appUrl = getOpenUserAppUrl(userId);
  const autoOpenAppUrl = getAutoOpenUserAppUrl(userId);
  const download = getDownloadInfo();

  useEffect(() => {
    const userAgent =
      typeof navigator === "undefined" ? "" : navigator.userAgent || "";
    const isCrawler =
      /bot|crawler|spider|facebookexternalhit|facebot|twitterbot|slackbot|discordbot|linkedinbot|pinterest|telegrambot|whatsapp|applebot|googlebot|bingbot/i.test(
        userAgent,
      );
    const isIOS =
      /iPhone|iPad|iPod/i.test(userAgent) ||
      (typeof navigator !== "undefined" &&
        navigator.platform === "MacIntel" &&
        navigator.maxTouchPoints > 1);
    const isAndroid = /Android/i.test(userAgent);

    if (
      typeof window === "undefined" ||
      !userId ||
      isCrawler ||
      new URLSearchParams(window.location.search).get("autoOpen") === "0" ||
      (!isIOS && !isAndroid)
    ) {
      return;
    }

    const timeout = window.setTimeout(() => {
      window.location.href = autoOpenAppUrl;
    }, 150);

    return () => window.clearTimeout(timeout);
  }, [autoOpenAppUrl, userId]);

  return (
    <Page>
      <Content>
        <Kicker>Bite profile</Kicker>
        <Title>A cook is waiting in Bite</Title>
        <Body>Open the app to view their profile and recipes.</Body>
        <Actions>
          <PrimaryButton href={appUrl}>Open in Bite</PrimaryButton>
          <SecondaryButton href={download.url} target="_blank" rel="noreferrer">
            {download.label}
          </SecondaryButton>
        </Actions>
      </Content>
    </Page>
  );
}

const Page = styled.main`
  min-height: calc(100vh - 170px);
  width: min(100% - 48px, 760px);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0 80px;

  @media (max-width: 760px) {
    width: min(100% - 30px, 560px);
    align-items: flex-start;
    padding-top: 12px;
  }
`;

const Content = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

const Kicker = styled.p`
  margin: 0;
  color: ${Colors.primaryColors.green};
  font-size: 14px;
  font-weight: 800;
`;

const Title = styled.h1`
  margin: 0;
  color: black;
  font-size: 54px;
  line-height: 0.95;
  letter-spacing: 0;

  @media (max-width: 760px) {
    font-size: 42px;
  }

  @media (max-width: 430px) {
    font-size: 34px;
  }
`;

const Body = styled.p`
  margin: 0;
  color: #626262;
  font-size: 19px;
  line-height: 1.45;

  @media (max-width: 760px) {
    font-size: 17px;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;

  @media (max-width: 760px) {
    width: 100%;
  }
`;

const PrimaryButton = styled.a`
  min-width: 150px;
  border-radius: 8px;
  background: black;
  color: ${Colors.white};
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 800;
  text-decoration: none;
  text-align: center;

  @media (max-width: 760px) {
    width: 100%;
  }
`;

const SecondaryButton = styled(PrimaryButton)`
  background: ${Colors.white};
  color: black;
  border: 1px solid rgba(0, 0, 0, 0.2);
`;

export default UserShare;
